import { queryOptions, useQuery } from '@tanstack/react-query'

import { useSelectedProjectStore } from '@/components/entities/common/model/selected-project.store'

import { NewsService } from '..'

export const NEWS_ITEM_DETAILS_QUERY_KEY = 'news-item-details'

interface Props {
  id: string
  projectId?: string
}

export const getNewsItemDetailsOptions = ({ id, projectId }: Props) => {
  return queryOptions({
    queryKey: [NEWS_ITEM_DETAILS_QUERY_KEY, id, projectId],
    queryFn: () => NewsService.getNewsById(id)
  })
}

export const useNewsItemDetails = ({ id }: Props) => {
  const { selectedProjectId } = useSelectedProjectStore()

  return useQuery(
    getNewsItemDetailsOptions({ id, projectId: selectedProjectId })
  )
}
